const standardLayout = () =>
`
  <ActionIcon />
  <ActionIcon disabled />
`;

const withCircleLayout = () =>
`
  <ActionIcon withCircle />
  <ActionIcon withCircle disabled />
`;

const navigationActionIcon = () =>
`
  <ActionIcon />
  <ActionIcon disabled />
`;

const withTextActionIcon = () =>
`
  <ActionIcon />
  <ActionIcon disabled />
`;

const withTooltipActionIcon = () => 
`
<Tooltip target={<ActionIcon />}>
  <Layout>
    <Row>
      <Title>Title</Title>
    </Row>
    <Row>
      <Description>Description Text Here Two lines</Description>
    </Row>
    <Row spaceBetween>
      <Label inline>label</Label>
      <Label inline>label</Label>
    </Row>
  </Layout>
</Tooltip>
`;

const actionIconsTemplates = {
  standard: standardLayout(),
  withCircle: withCircleLayout(),
  navigation: navigationActionIcon(),
  withText: withTextActionIcon(),
  withTooltip: withTooltipActionIcon()
};

export default actionIconsTemplates;


// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/constants/actionIconsTemplates.js